import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { Spinner } from 'components';
import * as styles from './SocialMediaSummary.scss';

var OverviewPreview = /*#__PURE__*/function (_Component) {
  _inherits(OverviewPreview, _Component);

  var _super = _createSuper(OverviewPreview);

  function OverviewPreview() {
    _classCallCheck(this, OverviewPreview);

    return _super.apply(this, arguments);
  }

  _createClass(OverviewPreview, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          allItems = _this$props.allItems,
          items = _this$props.items,
          section = _this$props.section,
          loading = _this$props.loading;
      return !loading ? /*#__PURE__*/React.createElement("div", {
        className: styles.overviewWrap
      }, items.map(function (item, index) {
        var newPageLikesObj = allItems.find(function (i) {
          return i.key === 'page_fan_adds_unique';
        }) || {};
        var newPageLikes = newPageLikesObj && newPageLikesObj.data ? newPageLikesObj.data.result : 0;

        if (item.key === 'page_fans') {
          return /*#__PURE__*/React.createElement("div", {
            key: index,
            className: styles.overviewItem
          }, parseInt(newPageLikes, 10) > 0 ? /*#__PURE__*/React.createElement("div", {
            className: styles.overviewArrowUp
          }, "\u2191") : /*#__PURE__*/React.createElement("div", {
            className: styles.overviewArrowUp
          }), /*#__PURE__*/React.createElement("div", {
            className: styles.overviewText
          }, /*#__PURE__*/React.createElement("span", {
            className: styles.overviewLabel
          }, item.label), /*#__PURE__*/React.createElement("span", {
            className: styles.overviewStat
          }, newPageLikes, " New Page Likes"), /*#__PURE__*/React.createElement("span", {
            className: styles.overviewStat
          }, item.data && item.data.fan_count ? item.data.fan_count : 0, " Total Page Likes")));
        }

        return /*#__PURE__*/React.createElement("div", {
          key: index,
          className: styles.overviewItem
        }, item.data && item.data.changeValue < 0 ? /*#__PURE__*/React.createElement("div", {
          className: styles.overviewArrowDown
        }) : /*#__PURE__*/React.createElement("div", {
          className: styles.overviewArrowUp
        }, "\u2191"), /*#__PURE__*/React.createElement("div", {
          className: styles.overviewText
        }, /*#__PURE__*/React.createElement("span", {
          className: styles.overviewLabel
        }, item.label), /*#__PURE__*/React.createElement("span", {
          className: styles.overviewStat
        }, item.data && item.data.result ? "".concat(item.data.result.toLocaleString(), " ").concat(item.dataPointText) : 0), item.data && item.data.changeDisplay && item.data.changeDisplay !== '∞%' && item.data.changeDisplay !== '0%' ? /*#__PURE__*/React.createElement("span", {
          className: styles.overviewStat
        }, "".concat(item.data.changeDisplay, " ").concat(item.data && item.data.changeValue && item.data.changeValue > 0 ? 'Increase' : 'Decrease')) : item.data && item.data.changeDisplay && item.data.changeDisplay !== '0%' ? /*#__PURE__*/React.createElement("span", {
          className: styles.overviewStat
        }, "\u221E Increase") : /*#__PURE__*/React.createElement("span", {
          className: styles.overviewStat
        }, "No Change")));
      })) : /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative',
          height: 75
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }));
    }
  }]);

  return OverviewPreview;
}(Component);

export { OverviewPreview as default };